import React, { useState, useRef, useEffect } from "react";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  EmailIcon,
} from "react-share";

interface SharePageProps {
  title: string;
}

const SharePage: React.FC<SharePageProps> = ({ title }) => {
  const [open, setOpen] = useState(false);
  const shareUrl = window.location.href;
  const popupRef = useRef<HTMLDivElement>(null);

  // Close when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  return (
    <div style={{ position: "relative" }} ref={popupRef}>
      {/* Main Share Button */}
      <button
        onClick={() => setOpen((prev) => !prev)}
        style={{
          padding: "10px 15px",
          cursor: "pointer",
          border: "1px solid #ccc",
          borderRadius: "30px",
        }}
      >
        📢 Share
      </button>

      {/* Popup with social buttons */}
      {open && (
        <div
          style={{
            position: "absolute",
            top: "50px",
            left: 0,
            background: "#fff",
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "8px",
            display: "flex",
            gap: "10px",
            zIndex: 999,
          }}
        >
          <FacebookShareButton url={shareUrl} hashtag="#myapp">
            <FacebookIcon size={32} round />
          </FacebookShareButton>
          <TwitterShareButton url={shareUrl} title={title}>
            <TwitterIcon size={32} round />
          </TwitterShareButton>
          <WhatsappShareButton url={shareUrl} title={title}>
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
          <EmailShareButton url={shareUrl} subject={title}>
            <EmailIcon size={32} round />
          </EmailShareButton>
        </div>
      )}
    </div>
  );
};

export default SharePage;
